import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { createIconTextBannerComponent } from '@vfde-brix/ws10/icon-text-banner';
import { HtmlId } from '../enums/elementId';

/**
 * Creates a WS10 Icon Text Banner component.
 */
export const mountIconTextBanner = (id: HtmlId) =>
    createComponentById(createIconTextBannerComponent, id, NO_PATTERN_BUSINESS_LOGIC);
